// extracted by mini-css-extract-plugin
export default {"Semibold":"GZAzLT5O"};